document.addEventListener('DOMContentLoaded', function () {

    let searchInput = document.querySelector('#input_search');
    let searchInputMobile = document.querySelector('#input_mobile');
    let searchContainer = document.querySelector('.search_container');
    let navbar = document.querySelector('.main-block');
    let searchResults = document.querySelector('#search_results');
    let closeSearch = document.querySelector('#close_search');

    for (let searchIcon of document.querySelectorAll('.icon-loupe:not(.disable-global-search)')) {
        searchIcon.addEventListener('click', function () {
            document.querySelector('body').style.overflowY = 'hidden';
            searchContainer.classList.toggle('search--active');
            searchInput.focus();
            navbar.classList.add('black');
        });
    }

    if (closeSearch) {
        closeSearch.addEventListener('click', function () {
            document.querySelector('body').style.overflowY = 'unset';
            searchContainer.classList.toggle('search--active');
            navbar.classList.remove('black');
        });
    }

    if (searchInputMobile) {
        searchInputMobile.addEventListener('focus', function () {
            document.querySelector('body').style.overflowY = 'hidden';
            searchContainer.classList.toggle('search--active');
            searchInput.focus();
        });
    }

    let page = 1;
    let stop = false;
    let waiting = false;
    let previousValue = ''

    let innerWidth = window.innerWidth

    let currentTimeout;
    if (searchInput) {
        searchInput.addEventListener('keyup', function (e) {
            if (previousValue === e.target.value) {
                return;
            }
            previousValue = e.target.value
            clearTimeout(currentTimeout);
            currentTimeout = setTimeout(function () {
                page = 1;
                if (e.target.value.length === 0) {
                    document.querySelector('body').style.overflowY = 'unset';
                    searchContainer.classList.toggle('search--active');
                    navbar.classList.remove('black');
                } else {
                    waiting = true;
                    innerWidth = window.innerWidth
                    fetch(Routing.generate('uc_fo_videoproduction_search_intellisense', {'term': e.target.value, 'screenWidth': innerWidth}))
                        .then(result => result.text())
                        .then(result => {
                            stop = result.trim() === "";
                            waiting = false;
                            searchResults.innerHTML = result;
                            if (searchResults.clientHeight === searchResults.scrollHeight && !waiting && !stop) {
                                fetchPage();
                            }
                        });
                    if (e.target.value.length === 0) {
                        navbar.classList.remove('black');
                    }
                }
            }, 300);
        });
    }

    if (searchResults) {
        searchResults.addEventListener('scroll', function() {
            if (stop || waiting) {
                return;
            }
            const fetchPadding = 50;
            if (searchResults.clientHeight + searchResults.scrollTop + fetchPadding >= searchResults.scrollHeight) {
                fetchPage();
            }
        });
    }

    fetchPage = () => {
        waiting = true
        page++
        fetch(Routing.generate('uc_fo_videoproduction_search_intellisense_page', {'term': searchInput.value, 'screenWidth': innerWidth, 'page': page}))
            .then(result => result.json())
            .then(result => {
                const tvodContainer = searchResults.querySelector('#results_Vod .search-images_container');
                const svodContainer = searchResults.querySelector('#results_Svod .search-images_container');
                const articlesContainer = searchResults.querySelector('#results_Article .search-articles_container');
                const artistsContainer = searchResults.querySelector('#results_Artist .search-artist_container');
                stop = result.tvod.trim() === "" && result.svod.trim() === "" && result.articles.trim() === "" && result.artists.trim() === "";
                tvodContainer.innerHTML = tvodContainer.innerHTML + result.tvod;
                svodContainer.innerHTML = svodContainer.innerHTML + result.svod;
                articlesContainer.innerHTML = articlesContainer.innerHTML + result.articles;
                artistsContainer.innerHTML = artistsContainer.innerHTML + result.artists;
                waiting = false;
            });
    }
});
